import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { Stack } from "@mui/material";
import AccordionSection from "./AccordionSection";

const AccordionSection1 = () => {
  return (
    <Stack
      sx={{
        // border: "1px solid red",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        my: 4,
      }}
    >
      <Accordion
        sx={{
          width: {
            xl: "70%",
            lg: "90%",
            xs: "92%",
            background:
              "linear-gradient(to right, #e9f1f9, #ecf2f7, #f9f6f0, #fef7ee)",
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          {/* for desktop */}
          <Stack
            sx={{
              display: { sm: "flex", xs: "none" },
              flexDirection: "column",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: {
                  xl: "21px",
                  lg: "21px",
                  md: "20px",
                  sm: "20px",
                  xs: "18px",
                },
                lineHeight: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                fontWeight: 600,
                color: "rgb(34, 34, 34)",
              }}
            >
              Adon Price Calculator
            </Typography>
            <Typography
              component="span"
              sx={{
                color: "#333", 
                fontSize: {
                  xl: "18px",
                  lg: "18px",
                  md: "16px",
                  sm: "16px",
                  xs: "14px",
                },
              }}
            >
              {" "}
              You can buy adon as per your business requirements, kindly note
              WhatsApp Managed Services is offered as paid adon and not included
              in any of the base plans
            </Typography>
          </Stack>

          {/* for mobile */}
          <Stack
            sx={{
              display: { sm: "none", xs: "flex" },
              flexDirection: "column",
            }}
          >
            <Typography
              component="span"
              sx={{
                fontSize: {
                  xl: "20px",
                  lg: "20px",
                  md: "20px",
                  sm: "20px",
                  xs: "20px",
                },
                lineHeight: {
                  xl: "40px",
                  lg: "40px",
                  md: "40px",
                  sm: "40px",
                  xs: "40px",
                },
                fontWeight: 600,
                color: "rgb(34, 34, 34)",
              }}
            >
              Adon Price Calculator
            </Typography>
            <Typography component="span">
              {" "}
              Calculate add-on costs quickly based on your specific needs and
              usage.
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionSection />
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

export default AccordionSection1;
